import { render, staticRenderFns } from "./orderMgtyw.vue?vue&type=template&id=88eec380&scoped=true&"
import script from "./orderMgtyw.vue?vue&type=script&lang=js&"
export * from "./orderMgtyw.vue?vue&type=script&lang=js&"
import style0 from "./orderMgtyw.vue?vue&type=style&index=0&id=88eec380&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eec380",
  null
  
)

export default component.exports